import script from "./FormPayNewPlanesComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPayNewPlanesComponente.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__